import React, { useEffect, useState } from "react";
import searcher from "../../../assets/icons/searchInput.svg";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import OnboardingDistributorListTable from "./onboarding-distributor-list-table";
import CreateBtn from "../../../components/buttons/createBtn";
import { useLocation, useNavigate } from "react-router-dom";

const OnboardingDistributor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");

  useEffect(() => {
    if (user_type === "super_admin") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Distributor" && item
      );

      setUserData(permissionValue);
    }
  }, [user_type]);

  return (
    <MainLayout>
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
            <img className="styled-SVG" src={searcher} alt="o" />
            <input
              value={search}
              className="search-input fs_14 fw_400 px-2 text-dark"
              type="text"
              placeholder="Search distributors here by distributor ID, distributor name..."
              onChange={(e) => {
                navigate(
                  `/distributors/onboard-distributor?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }${queryString}`
                );
              }}
            />
          </div>
          <div className=" d-flex justify-content-between m-1 mb-2">
            <button
              onClick={() => navigate(`/distributors/onboard-distributor`)}
              className="py-1 border-0 rounded-2 mx-2  px-3 fs_14 Medium_Purple"
            >
              Clear Filters
            </button>
            {(user_type === "super_admin" && userData?.write) ||
            user_type === "admin" ? (
              <CreateBtn link="/distributors/onboard-distributor/create" />
            ) : (
              ""
            )}
          </div>
        </div>

        <OnboardingDistributorListTable
          search={search}
          status={status}
          page_no={page_no}
        />
      </div>
    </MainLayout>
  );
};

export default OnboardingDistributor;
